import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/logo.jpeg";

function Footer() {
  const content = [
    {
      title: "Blogs",
      href: "/",
    },
    {
      title: "Contact Us",
      href: "/contactus",
    },
    {
      title: "FAQ",
      href: "/frequently-asked-questions",
    },
    {
      title: "About Website",
      href: "/about",
    },
    // {
    //   title: "Privacy Policy",
    //   href: "/privacy-policy",
    // },
  ];
  const AboutMe = [
    {
      title: "Github",
      href: "https://github.com/MuhammadAliashraf",
    },
    {
      title: "linkedin",
      href: "https://www.linkedin.com/in/muhammadaliashraf01/",
    },
    {
      title: "Visit My Portfolio",
      href: "https://portfolio-457fb.web.app/",
    },
  ];
  const letsTalk = [
    {
      title: "+92 306-2767-542",
      // href: "",
    },
    {
      title: "alijutt030627@gmail.com",
      href: "mailto:alijutt030627@gmail.com",
    },
  ];

  return (
    <>
      <footer class=" mx-auto w-10/12 border-t mt-12 pt-12 pb-5 px-4 lg:px-0">
        <div class="flex flex-wrap">
          <div class="w-full lg:w-2/5">
            <div className="h-[100px] w-[100px]">
              <img
                src={Logo}
                height="100%"
                className="rounded-full"
                width="100%"
              />
            </div>
            <p class="text-gray-600 hidden lg:block p-0 lg:pr-12">
              Boisterous he on understood attachment as entreaties ye
              devonshire. In mile an form snug were been sell. Extremely ham any
              his departure for contained curiosity defective. Way now
              instrument had eat diminution melancholy expression sentiments
              stimulated.
            </p>
          </div>
          <div class="w-full mt-6 lg:mt-0 md:w-1/2 lg:w-1/5">
            <h6 class="font-semibold text-gray-700 mb-4">Content</h6>
            <ul>
              {content.map((item) => (
                <li>
                  <Link
                    to={item.href}
                    class="block text-gray-600 transition ease-in-out duration-300 hover:underline hover:underline-offset-8 hover:font-medium hover:text-teal-800 py-2"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div class="w-full mt-6 lg:mt-0 md:w-1/2 lg:w-1/5">
            <h6 class="font-semibold text-gray-700 mb-4">About Me</h6>
            <ul>
              {AboutMe.map((item) => (
                <li>
                  <Link
                    to={item.href}
                    class="block text-gray-600 transition ease-in-out duration-300 hover:underline hover:underline-offset-8 hover:font-medium hover:text-teal-800 py-2"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div class="w-full mt-6 lg:mt-0 md:w-1/2 lg:w-1/5">
            <h6 class="font-semibold text-gray-700 mb-4">Let's Talk</h6>
            <ul>
              {letsTalk.map((item) => (
                <li>
                  <Link
                    to={item.href}
                    class="block text-gray-600 transition ease-in-out duration-300 hover:underline hover:underline-offset-8 hover:font-medium hover:text-teal-800 py-2"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div class="bg-gray-100">
          <div class="mx-auto flex max-w-screen-xl flex-col gap-y-4 px-4 py-3 text-center text-gray-500 sm:flex-row sm:justify-between sm:text-left">
            <div class="">© 2024 Muhammad Ali | All Rights Reserved</div>
            <div class="">
              <Link class="mx-2" to="#">
                Privacy Policy
              </Link>
              <span>|</span>
              <Link class="mx-2" to="#">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
